/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ls_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lines are ordered by the number at the start of each line, so '2' comes before '10'. Lines without a leading number are placed last.`)
};

const es_ls_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las líneas se ordenan por el número al inicio de cada línea, por lo que '2' viene antes que '10'. Las líneas sin número inicial se colocan al final.`)
};

const de_ls_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Zeilen werden nach der Zahl am Anfang jeder Zeile geordnet, sodass '2' vor '10' steht. Zeilen ohne eine vorangestellte Zahl werden ans Ende gestellt.`)
};

const nl_ls_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regels worden geordend op basis van het getal aan het begin van elke regel, dus '2' komt voor '10'. Regels zonder een voorafgaand getal worden als laatste geplaatst.`)
};

const fr_ls_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les lignes sont ordonnées par le nombre au début de chaque ligne, donc « 2 » vient avant « 10 ». Les lignes sans nombre au début sont placées en dernier.`)
};

const it_ls_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le righe vengono ordinate in base al numero all'inizio di ogni riga, quindi '2' viene prima di '10'. Le righe senza un numero iniziale vengono posizionate per ultime.`)
};

const pt_br2_ls_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As linhas são ordenadas pelo número no início de cada linha, portanto '2' vem antes de '10'. As linhas sem um número no início são colocadas por último.`)
};

const pt_ls_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As linhas são ordenadas pelo número no início de cada linha, portanto '2' vem antes de '10'. Linhas sem número à frente são colocadas por último.`)
};

const ja_ls_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`行は各行の最初の数字でソートされるため、「2」は「10」の前に来ます。最初に数字がない行は最後に配置されます。`)
};

const zh_ls_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`各行会按每行开头的数字排序，因此“2”排在“10”之前。没有前导数字的行会被放在最后。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ls_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ls_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ls_faq1_a", locale)
	if (locale === "en") return en_ls_faq1_a(inputs)
	if (locale === "es") return es_ls_faq1_a(inputs)
	if (locale === "de") return de_ls_faq1_a(inputs)
	if (locale === "nl") return nl_ls_faq1_a(inputs)
	if (locale === "fr") return fr_ls_faq1_a(inputs)
	if (locale === "it") return it_ls_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_ls_faq1_a(inputs)
	if (locale === "pt") return pt_ls_faq1_a(inputs)
	if (locale === "ja") return ja_ls_faq1_a(inputs)
	return zh_ls_faq1_a(inputs)
};